import React from "react";
import { useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import { hideCardRef } from "../../helpers";
import * as yup from "yup";

export const PromoModal = ({
  promoCardRef,
  handleApplyCode,
  promotionalBonus
}) => {
  const validCode = `ADD${promotionalBonus}`;
  const schema = yup.object().shape({
    code: yup
      .string()
      .test(
        "match",
        `Please enter code ADD${promotionalBonus}`,
        (code) => code.toUpperCase() === validCode
      )
      .max(8, "Maximum of 8 characters")
      .required(`Enter code ADD${promotionalBonus} to continue`)
  });
  const {
    register,
    handleSubmit,
    formState: { errors }
  } = useForm({
    resolver: yupResolver(schema)
  });

  return (
    <div className="modal__promo" ref={promoCardRef}>
      <div className="modal-content ch-pa--3 ch-card">
        <form onSubmit={handleSubmit(handleApplyCode)}>
          <div className="ch-display--flex ch-justify-content--between">
            <p className="ch-fs--3 ch-text--bold ch-mb--0">Enter promo code</p>
            <span
              className="icon__close"
              onClick={() => hideCardRef(promoCardRef)}
            ></span>
          </div>
          <p className="code-reminder ch-mb--0 ch-text--left">
            Use code ADD{promotionalBonus}
          </p>
          {errors?.code && (
            <span className="ch-color--ac-red ch-text--bold ch-mt--4 ch-fs--2">
              {errors.code.message}
            </span>
          )}
          <input
            name="code"
            className="ch-form__control ch-text--uppercase"
            type="text"
            id="code"
            {...register("code")}
            autoComplete="off"
          />

          <input
            className={`ch-btn ch-btn--primary ch-mt--2 ch-width--12`}
            type="submit"
            value="Apply code"
          />
        </form>
      </div>
    </div>
  );
};
